module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"summary":{"total":"There are {0} unpaid orders for {1}:","description":"Pending payment.","hint":"( As of {0} )"},"order":{"code":"Order number: {0}","created_at":"Order date: {0}","bank_account":"{0} {1} {2}","sender_name":"( Depositor: {0} )","copy_bank_account_no":"Copy account number"}}}')
  delete Component.options._Ctor
}
